import React from "react";
import { Link } from "gatsby";

const GuideMainHeader = ({ subjectContent }) => (
  <div>
    <div className="g-header">
      <div className="container ">
        <div className="g-header__title">
          <h1 className="g-header__title--h1">VdoCipher Glossary</h1>
        </div>
        <div className="g-header__subtitle">
          <p className="g-header__subtitle--p">
            Simple explanations of Video Streaming Terminologies & Concepts
          </p>
        </div>
        <div className="g-header__card-container">
          {subjectContent.map((subject, i) => (
            <GuideCard
              key={i}
              subjectId={subject.subjectId}
              icon={subject.icon}
              subject={subject.subject}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

const GuideCard = ({ subjectId, icon, subject }) => {
  return (
    <div className="g-header__card g-header__card--width-responsive">
      <Link
        className="g-header__card--link-white"
        to={`/glossary/${subjectId}`}
      >
        <div className="g-header__card_logo">
          <span className={icon}></span>
          <h3 className="g-header__card-text--padding-20">{subject}</h3>
        </div>
      </Link>
    </div>
  );
};
export default GuideMainHeader;
